<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="active-business-process-container pa-4">
    <div class="d-flex flex-row flex-nowrap">
      <v-btn icon @click.stop="toggleCards">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div>
        <v-btn icon @click="setActiveTab('information')" :color="tab === 'information' ? 'primary' : ''">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
        <v-btn icon @click="setActiveTab('agents')" :color="tab === 'agents' ? 'primary' : ''">
          <v-icon>mdi-account</v-icon>
        </v-btn>
        <v-btn icon @click="setActiveTab('supervisors')" :color="tab === 'supervisors' ? 'primary' : ''">
          <v-icon>mdi-badge-account</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="active-tab-item">
      <v-tabs-items :value="tab" class="background-surface-base">
        <v-tab-item value="information">
          <EcsGeneralInformationView
            :business-process="businessProcess"
            :default-from-email="defaultFromEmail"
            :default-bcc-email="defaultBccEmail"
          />
        </v-tab-item>
        <v-tab-item value="agents">
          <EcsAssignedAgents :items="businessProcess.agentsAssigned" :title="$t('activeBusinessProcessCard.agents')" />
        </v-tab-item>
        <v-tab-item value="supervisors">
          <EcsAssignedAgents
            :items="businessProcess.supervisorsAssigned"
            :title="$t('activeBusinessProcessCard.supervisors')"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import EcsGeneralInformationView from '@/components/ecs-summary-view/EcsGeneralInformationView';
import EcsAssignedAgents from '@/components/ecs-summary-view/EcsAssignedAgents';

export default {
  name: 'EcsActiveBusinessProcessSummaryCard',

  components: { EcsGeneralInformationView, EcsAssignedAgents },

  props: {
    businessProcess: {
      type: Object,
      required: true
    },

    defaultFromEmail: {
      type: String,
      required: true
    },

    defaultBccEmail: {
      type: String,
      required: true
    },

    toggleCards: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      tab: 'information'
    };
  },

  methods: {
    setActiveTab(tab) {
      this.tab = tab;
    }
  }
};
</script>

<style scoped>
.active-business-process-container {
  height: 100%;
  max-height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
.active-tab-item {
  overflow-y: scroll;
}
</style>
